import {
    DEALERDELETEDSR_SUCCESS,
    DEALERDELETEDSR_FAILED,
    RESET_DEALERDELETEDSR,
    LOADING_DEALERDELETEDSR,
    NETWORK_ERROR_DEALERDELETEDSR
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERDELETEDSR:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERDELETEDSR_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERDELETEDSR_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERDELETEDSR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERDELETEDSR:
            return (state = initialState);
        default:
            return state;
    }
};